import { useState } from 'react';
import { generateUUID } from '../utils/orderUtils';

/**
 * Custom hook for managing cart state
 * @returns {Object} Cart state and actions
 */
export const useCart = () => {
  const [cart, setCart] = useState([]);

  const addToCart = (product) => {
    const item = {
      id: generateUUID(),
      ...product,
      createdAt: Date.now(),
    };
    setCart((c) => [item, ...c]);
  };

  const removeFromCart = (id) => {
    setCart((c) => c.filter((it) => it.id !== id));
  };

  const clearCart = () => {
    setCart([]);
  };

  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  return {
    cart,
    addToCart,
    removeFromCart,
    clearCart,
    getTotalItems,
  };
};